import {
  FETCH_ORDER_DETAILS_ERROR,
  FETCH_ORDER_DETAILS_REQUEST,
  FETCH_ORDER_DETAILS_SUCCESS,
  FETCH_ORDERS_SUMMARY_ERROR,
  FETCH_ORDERS_SUMMARY_REQUEST,
  FETCH_ORDERS_SUMMARY_SUCCESS,
} from '../actions/ordersSummary';

export const initialState = {
  error: null,
  futureOrdersCount: null,
  futureSeasonalOrdersCount: null,
  nextOrder: null,
};

export default function ordersSummary(state = initialState, action) {
  switch (action.type) {
    case FETCH_ORDERS_SUMMARY_SUCCESS: {
      const { data } = action;

      return {
        ...initialState,
        futureOrdersCount: data.futureOrdersCount,
        futureSeasonalOrdersCount: data.futureSeasonalOrdersCount,
        nextOrder: data.nextOrder || null,
      };
    }
    case FETCH_ORDERS_SUMMARY_ERROR: {
      return {
        ...initialState,
        error: action.error,
      };
    }

    case FETCH_ORDER_DETAILS_SUCCESS: {
      const { data } = action;

      return {
        ...state,
        nextOrder: { ...data },
      };
    }
    case FETCH_ORDER_DETAILS_ERROR: {
      return {
        ...state,
        error: action.error,
      };
    }

    case FETCH_ORDERS_SUMMARY_REQUEST:
    case FETCH_ORDER_DETAILS_REQUEST:
    default:
      return state;
  }
}
